import React, { useState, useEffect } from "react";
import { axiosInstance } from "../axiosInstance";

const SocialMedia = () => {
  const [instagramMediaItems, setInstagramMediaItems] = useState(null);

  const getInstagramPosts = () => {
    return axiosInstance.get(`/social-media/instagram/posts`);
  };

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const response = await getInstagramPosts();
        setInstagramMediaItems(response.data);
      } catch (error) {
        console.error("Error fetching instagram posts:", error);
      }
    };
    fetchInstagramPosts();
  }, []);

  return (
    <>
      <div className="heading-wrapper text-center mb-4" data-aos="fade-down">
        <h4>SOCIAL MEDIA UPDATES</h4>
        <div className="line-with-dots mb-3">
          <div className="dot"></div>
          <div className="line"></div>
          <div className="dot"></div>
        </div>
      </div>

      {instagramMediaItems && (
        <div className="container">
          <div className="row">
            {instagramMediaItems.data.map((item, index) => {
              if (item.media_type === "VIDEO") {
                return (
                  <>
                    <div className="col-md-4 my-2 col-12">
                      <video
                        style={{ objectFit: "fill" }}
                        className="border shadow rounded-3"
                        height="400px"
                        width="100%"
                        poster={item.thumbnail_url}
                        controls
                        playsInline
                      >
                        <source src={item.media_url}></source>
                      </video>
                    </div>
                  </>
                );
              } else if (
                item.media_type === "IMAGE" ||
                item.media_type === "CAROUSEL_ALBUM"
              ) {
                return (
                  <>
                    <div className="col-md-4 my-2 col-12">
                      <img
                        className="border shadow rounded-3"
                        style={{ objectFit: "fill" }}
                        src={item.media_url}
                        alt={item.caption}
                        height="400px"
                        width="100%"
                      ></img>
                    </div>
                  </>
                );
              }
              return null;
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default SocialMedia;
